module.exports = __webpack_public_path__ + "8cb296dea5f3aeb48e0b67dcbadc5913.pdf";